import React, { Suspense } from 'react';
var LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_linkdatasource-datasourceRenderFailedAnalyticsWrapper" */'./datasourceRenderFailedAnalyticsWrapper');
});
export var LazyLoadedDatasourceRenderFailedAnalyticsWrapper = function LazyLoadedDatasourceRenderFailedAnalyticsWrapper(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LazyDatasourceRenderFailedAnalyticsWrapper, props));
};